module.exports = __webpack_public_path__ + "static/img/YeJiGuanLiJiaShiCang.a5fac127.jpg";